import React, { useState } from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import Table from "../../../ui/Table";
import Modal from "../../../ui/Modal";
import { EditDeleteFormatter } from "../../../ui/TableFormatter";
import { useRouteMatch, useLocation } from "react-router-dom";
import { get } from "../../../utils/get";
import axios from "../../../utils/axios";
import {
  SCORECARD_URL,
  PERIOD_URL,
  USER_URL,
  ORGANISATION_URL,
  STRATEGYMAP_URL,
} from "../../../api/urls";
import { GetHook } from "../../../api/api";
import { parseDropdown } from "../../../utils/parseDropdown";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import AddStrategymapForm from "./AddStrategymapForm";

const StrategymapListView = (props) => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [editData, setEditData] = useState({});
  const [edit, setEdit] = useState(false);
  const [filter, setFilter] = useState({});

  const location = useLocation();

  const { data: strategymaps, reload } = GetHook(`${STRATEGYMAP_URL}`);
  const { data: scorecards } = GetHook(`${SCORECARD_URL}`);
  const { data: periods } = GetHook(PERIOD_URL);
  const { data: owners } = GetHook(USER_URL);
  const { data: organisations } = GetHook(ORGANISATION_URL);

  const { url } = useRouteMatch();

  const handleEdit: any = (e, row: any) => {
    setisModalOpen(true);
    setEdit(true);
    setEditData(row);
  };

  const { history } = props;
  const closeModal = () => {
    setisModalOpen(false);
    setEdit(false);
    setEditData({});
    reload(get(location, "key"));
  };

  const setScorecard = (rowobject) => {
    const { id } = get(rowobject, "original");
    history.push(`${url}/${id}`);
  };

  const handleDelete = (e, id: string) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          axios
            .delete(`${STRATEGYMAP_URL}/${id}`)
            .then(() => {
              toast.success("Strategymap has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };

  const columns = [
    {
      Header: "Title",
      accessor: "name",
    },
    {
      Header: "Scorecard",
      accessor: "scorecard.name",
    },
    {
      Header: "Owner",
      accessor: "owner.name",
    },
    {
      Header: "Notes",
      accessor: "notes",
    },
    {
      id: "1",
      Header: "",
      Cell: ({ row }: any) => (
        <EditDeleteFormatter
          isArchived={row.original.status === "archived"}
          showEdit={(e) => handleEdit(e, row.original)}
          handleDelete={(e) => handleDelete(e, row.original.id)}
        />
      ),
    },
  ];

  return (
    <Container>
      <HeaderContainer>
        <TitleText>Strategymap</TitleText>
      </HeaderContainer>
      <Table
        data={strategymaps}
        columns={columns}
        setModal={setisModalOpen}
        setScorecard={setScorecard}
        periods={parseDropdown(periods)}
        owners={parseDropdown(
          get(filter, "organisation")
            ? owners.filter(
                (owner) =>
                  owner.organisation_id === get(filter, "organisation_id")
              )
            : owners
        )}
        organisations={parseDropdown(organisations)}
        filter={filter}
        setFilter={setFilter}
      />
      {isModalOpen && (
        <Modal
          title={edit ? "Edit strategy map" : "Add new strategy map"}
          handleSubmit={handleSubmit}
          closeModal={closeModal}
        >
          <AddStrategymapForm
            closeModal={closeModal}
            setHandleSubmit={setHandleSubmit}
            scorecards={scorecards}
            editData={editData}
          />
        </Modal>
      )}
    </Container>
  );
};

export default StrategymapListView;

const Container = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  background-color: #fff;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;
